var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuAir({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8192_25",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8192_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 21.0001V19.0001H21V21.0001H3ZM4.75 16.0001L1 9.7501L3.4 9.1001L6.2 11.4501L9.7 10.5251L4.525 3.6251L7.425 2.8501L14.9 9.1251L19.15 7.9751C19.6833 7.8251 20.1875 7.8876 20.6625 8.1626C21.1375 8.4376 21.45 8.84176 21.6 9.3751C21.75 9.90843 21.6875 10.4126 21.4125 10.8876C21.1375 11.3626 20.7333 11.6751 20.2 11.8251L4.75 16.0001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAir);
export default __webpack_public_path__ + "static/media/menu_air.b9fc653c7b3a73e9532b8fab35eadd34.svg";
export { ForwardRef as ReactComponent };